import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=84bdf9ca&scoped=true"
import script from "./shareDialog.vue?vue&type=script&lang=js"
export * from "./shareDialog.vue?vue&type=script&lang=js"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=84bdf9ca&prod&lang=scss&scoped=true"
import style1 from "./shareDialog.vue?vue&type=style&index=1&id=84bdf9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bdf9ca",
  null
  
)

export default component.exports